<template>
  <div
    class="header flex vertical space-between"
    :style="[customInfo ? { backgroundImage: `url(${customInfo.inner_pic_url})` } : '']"
  >
    <div v-if="!isCustom" class="logo"></div>
    <div v-if="isCustom" class="logo-custom">{{ customInfo.name }}</div>
    <div class="header-action flex vertical">
      <div
        class="btn-teachers-day"
        name="Teachers_Day_Second_Popup_Icon"
        v-if="isTeacher && isTeachersDay"
        @click="showTeachersDay"
      ></div>
      <div
        class="btn-training-camp"
        name="Trainingpopup_Icon"
        v-if="isTeacher && isTrainingCamp"
        @click="showTrainingCamp"
      ></div>
      <div
        class="btn-new-semester"
        name="New_Semester_Popup_Icon"
        v-if="isTeacher && isNewSemester"
        @click="showNewSemester"
      ></div>

      <div class="weixin-group" v-if="isTeacher">
        <div class="flex has-qrcode">
          <icon-question-discuss />
          平台答疑
          <div class="qr-code-con">
            <img class="con-left" :src="weixinGroupQrcode" />
            <div class="con-right">
              扫码咨询
              <br />
              <span>微信扫一扫，添加微信群进行咨询</span>
            </div>
          </div>
        </div>
        <div class="tips" v-if="visibleWeixinGroupTips">
          如果对平台使用有任何问题，可移动鼠标至此位置添加平台微信群咨询
          <img class="icon-close" @click="hideWeixinGroupTips" src="./close_icon.png" />
        </div>
      </div>

      <div class="flex" v-if="isTeacher" @click.self="() => openHelpDoc('clickTipTitle')">
        <icon-help />
        操作指南
        <el-badge v-if="helpred === 0" is-dot class="red-help"></el-badge>
      </div>
      <div
        class="flex"
        v-if="
          (isCustom && headMenu['discuss']) ||
          (!isCustom && $store.getters.roleType && $store.getters.roleType !== 'student')
        "
        @click="toForum"
      >
        <icon-discuss />
        教学讨论
      </div>
      <!-- <div class="flex has-qrcode" v-if="(isCustom && headMenu['nemo']) || !isCustom">
        <icon-phone />
        手机编程
        <div class="qr-code-con">
          <img
            class="con-left"
            src="https://public-static-edu.codemao.cn/redboat/static/header-nemo-qrcode@2x.png"
          />
          <div class="con-right">
            口袋里的创作工具
            <br />
            <span>扫一扫即刻下载</span>
          </div>
        </div>
      </div>
      <div v-if="(isCustom && headMenu['parent']) || !isCustom" class="flex has-qrcode">
        <icon-qrcode />
        家长端
        <div class="qr-code-con">
          <img class="con-left" src="./exported_qrcode_image.png" />
          <div class="con-right">
            微信扫一扫
            <br />
            <span>进入家长端</span>
          </div>
        </div>
      </div> -->
      <template v-if="role_id">
        <div
          v-if="role_id !== 40001"
          :class="['flex', 'notice', { animate: unread }]"
          @click="mail"
        >
          <el-badge v-if="unread" is-dot class="badge"></el-badge>
          <icon-bell />
        </div>

        <el-dropdown class="user-menu" @command="command">
          <span v-if="user">
            <text-with-tip
              :content="user.real_name || user.fullname || user.nickname"
              placement="left"
            />
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="!isCustom" command="1">返回</el-dropdown-item>
            <el-dropdown-item command="2">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IconQuestionDiscuss from '@/assets/svg/icon_question_discuss.svg'
// import IconQuestion from '@/assets/svg/icon_question.svg'
import IconDiscuss from '@/assets/svg/icon_discuss.svg'
// import IconPhone from '@/assets/svg/icon_phone.svg'
// import IconQrcode from '@/assets/svg/icon_qrcode.svg'
import IconBell from '@/assets/svg/icon_bell.svg'
import IconHelp from '@/assets/svg/icon_help.svg'
import { isNewSemester } from '../newSemester'

export default {
  components: {
    IconQuestionDiscuss,
    // IconQuestion,
    IconDiscuss,
    // IconPhone,
    // IconQrcode,
    IconBell,
    IconHelp
  },
  data() {
    return {
      visibleWeixinGroupTips: false,
      weixinGroupQrcode: '', // 平台答疑二维码
      headMenu: {},
      isShowTip: false,
      guidePayload: {}
    }
  },
  props: {
    noinit: Boolean
  },
  computed: {
    ...mapState(['user', 'customInfo', 'dashboard']),
    isCustom() {
      return this.customInfo
    },
    unread() {
      return this.$store.state.mail.unread
    },
    helpred() {
      return this.dashboard.helpRed
    },
    role_id() {
      return (this.$store.state.user || {}).role_id
    },
    tempMenus() {
      return this.dashboard.tempMenus
    },
    menuName() {
      return this.dashboard.menuName.headEntry
    },
    headEntry() {
      return this.dashboard.headEntry
    },
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    },
    // 教师节第一阶段活动时间
    isTeachersDay() {
      return moment().isBetween(moment('2022/09/08'), moment('2022/09/26'))
    },
    // 教师训练营活动时间
    isTrainingCamp() {
      return moment().isBetween(moment('2022/12/19'), moment('2022/12/23'))
    },
    // 开学季活动
    isNewSemester
  },
  watch: {
    tempMenus: {
      handler: function (val) {
        val.forEach((value) => {
          if (this.menuName.indexOf(value.custom_menu_id) === -1) return
          if (value.sub_menus) {
            value.sub_menus.forEach((item) => {
              for (const [key, val] of Object.entries(this.headEntry)) {
                if (key.indexOf(item.custom_menu_id) > -1) {
                  this.headMenu[val] = 1
                }
              }
            })
          }
        })
      },
      deep: true,
      immediate: true
    },
    guidePayload: {
      handler: function (val) {
        if (!val.helperCenterStatus) {
          setTimeout(() => {
            this.isShowTip = true
          }, 500)
        }
      }
    },
    'user.id'(value) {
      // 平台答疑提示
      if (!value) {
        this.visibleWeixinGroupTips = false
      }
      const users = JSON.parse(localStorage.getItem('visibleWeixinGroupTips') || '[]')
      this.visibleWeixinGroupTips = users.length === 0 || users.indexOf(value) === -1
    }
  },
  mounted() {
    if (this.noinit) return
    this.getGuideType()
    this.getWeixinGroupQrcode()
  },
  methods: {
    // 获取平台答疑二维码
    async getWeixinGroupQrcode() {
      const { data } = await API.get('/edu/base/general/conf', {
        tag: 'teacher_guided_wechat_link'
      })
      this.weixinGroupQrcode = data.content
    },
    toForum() {
      window.open(window.CONFIG.forum)
    },
    openHelpDoc(key) {
      this.$store.dispatch('eduCommonReport', {
        key
      })
      if (this.helpred === 0) {
        // 只有显示红点了才上报
        this.$store.dispatch('updateHelpRed')
      }
      this.setGuideType('helperCenterStatus', 3)
      const target = '/documents'
      window.open(target)
    },
    closeDoc() {
      this.$store.dispatch('eduCommonReport', {
        key: 'clickTipClose'
      })
      this.setGuideType('helperCenterStatus', 3)
    },
    // 获取引导状态
    async getGuideType() {
      const { data } = await this.$store.dispatch('getGuideType')
      this.guidePayload = data
    },
    // 设置引导状态
    async setGuideType(key, remindType) {
      // helperCenterStatus: 3
      // openLessonStatus: 2
      if (!this.guidePayload[key]) {
        await this.$store.dispatch('setGuideType', remindType)
        this.guidePayload[key] = true
        this.$nextTick(() => {
          this.isShowTip = false
        })
      }
    },
    command(command) {
      switch (command) {
        case '1':
          this.goBack()
          break
        case '2':
          this.logout()
          break
      }
    },
    logout() {
      this.$store.dispatch('logout')
    },
    async goBack() {
      window.location.replace(CONFIG.school)
    },
    selectLang(str) {
      switch (str) {
        case '中文':
          sessionStorage.setItem('lang', 'zh-CN')
          break
        case 'en':
          sessionStorage.setItem('lang', 'en')
          break
      }
      window.location.reload()
    },
    showGuide() {
      this.$emit('play')
    },
    mail() {
      this.$router.push('/mail')
    },
    showTeachersDay() {
      this.$emit('showTeachersDay')
    },
    showTrainingCamp() {
      this.$emit('showTrainingCamp')
    },
    showNewSemester() {
      this.$emit('showNewSemester')
    },
    hideWeixinGroupTips() {
      this.visibleWeixinGroupTips = false
      let users = localStorage.getItem('visibleWeixinGroupTips')
      if (users) {
        users = JSON.parse(users)
        users.push(this.user.id)
      } else {
        users = [this.user.id]
      }
      localStorage.setItem('visibleWeixinGroupTips', JSON.stringify(users))
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  padding: 8px 20px;
  background: var(--primary-color);
  min-height: 60px;
  background-position: center;
  background-size: cover;
  .logo {
    width: 260px;
    height: 29px;
    background: url(https://education.codemao.cn/27/eduzone/1/logo.png) no-repeat 0 0 / contain;
  }
  .logo-custom {
    color: #fff;
    font-size: 29px;
  }
}
.header-action {
  .btn-teachers-day,
  .btn-training-camp,
  .btn-new-semester {
    margin: -6px 27px 0 0;
    width: 166px;
    height: 48px;
    background: no-repeat 0 0 / 100% auto;
    cursor: pointer;
  }
  .btn-teachers-day {
    background-image: image-set(
      url(../../assets/image/btn_teachers_day.png) 1x,
      url(../../assets/image/btn_teachers_day@2x.png) 2x
    );
  }
  .btn-training-camp {
    background-image: image-set(
      url(../../assets/image/btn_training_camp.png) 1x,
      url(../../assets/image/btn_training_camp@2x.png) 2x
    );
  }
  .btn-new-semester {
    background-image: image-set(
      url(../../assets/image/newyear2024-nav.png) 1x,
      url(../../assets/image/newyear2024-nav@2x.png) 2x
    );
  }
  svg {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
  & > div {
    position: relative;
    margin-right: 40px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
  }
  .weixin-group {
    .tips {
      position: absolute;
      top: 30px;
      left: -125px;
      display: flex;
      padding: 13px 20px;
      width: 330px;
      background: #fff;
      color: #333;
      font-size: 12px;
      border-radius: 8px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 159px;
        border: 6px solid transparent;
        border-top: 0;
        border-bottom-color: #fff;
      }
    }
    .icon-close {
      margin-left: 15px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .has-qrcode {
    &:hover {
      .qr-code-con {
        z-index: 1002;
        opacity: 1;
      }
    }
  }
  .red-help {
    position: absolute;
    top: -8px;
    right: -7px;
    z-index: 1;
  }
  .notice {
    .badge {
      position: absolute;
      top: -9px;
      right: 3px;
      z-index: 1;
    }
    svg {
      position: relative;
      width: 16px;
      height: 16px;
    }
  }
  .user-menu {
    margin-right: 0;
  }
}

.qr-code-con {
  padding: 20px;
  position: absolute;
  background: #fff;
  top: 38px;
  right: -10px;
  border-radius: 8px;
  box-shadow: 0 2px 20px 0 rgba(198, 199, 199, 0.5);
  z-index: -1;
  opacity: 0;
  transition: all 0.5s;
  &:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent #fff;
    position: absolute;
    top: -6px;
    right: 20px;
  }
  .con-left {
    display: block;
    width: 120px;
  }
  .con-right {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
    text-align: center;
    span {
      color: #818786;
      font-size: 12px;
    }
  }
}

.animate {
  &:hover {
    animation: tada 0.7s linear;
  }
}

@keyframes tada {
  10%,
  20% {
    transform: rotate3d(0, 0, 1, -10deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: rotate3d(0, 0, 1, 10deg);
  }

  40%,
  60%,
  80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
}
</style>
